import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import CreateEdizioneModal from './modal/createEdizioneModal';
import './AEdizioni.css';
import API from '../../api/API';

const Edizioni = () => {
  const navigate = useNavigate();
  const [edizioni, setEdizioni] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [filterStatus, setFilterStatus] = useState('all');
  const [filterCategoria, setFilterCategoria] = useState('all');
  const [currentPage, setCurrentPage] = useState(1);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [editingEdizione, setEditingEdizione] = useState(null);
  const itemsPerPage = 9;

  // Mock data per le edizioni
  const mockEdizioni = [
    {
      id: 101,
      torneo: "Torneo Nazionale Scoutball",
      edizione: "XV Edizione",
      luogo: "Parco dei Cedri, Bologna",
      quota: "25€",
      caparra: 10,
      dataInizio: "2024-09-15",
      dataFine: "2024-09-15",
      locandina: null,
      categoria: "E/G, R/S",
      censiti: "Tutti",
      chiusuraIscrizioni: "2024-09-01",
      chiusuraModifiche: "2024-09-10",
      avvio: "2024-08-01",
      chiusura: null,
      foto: null,
      status: "active",
      squadreIscritte: 42,
      squadreConfermate: 38
    },
    {
      id: 201,
      torneo: "Coppa dei Corni Grigi",
      edizione: "VIII Edizione",
      luogo: "Campo Scout Sasso Marconi",
      quota: "15€",
      caparra: 5,
      dataInizio: "2024-06-10",
      dataFine: "2024-06-10",
      locandina: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEA...",
      categoria: "L/C",
      censiti: "Solo AGESCI",
      chiusuraIscrizioni: "2024-05-25",
      chiusuraModifiche: "2024-06-05",
      avvio: "2024-05-01",
      chiusura: "2024-06-11",
      foto: "https://example.com/foto.jpg",
      status: "completed",
      squadreIscritte: 24,
      squadreConfermate: 24
    },
    {
      id: 301,
      torneo: "Torneo di Primavera",
      edizione: "XII Edizione",
      luogo: "Parco della Montagnola",
      quota: "20€",
      caparra: 8,
      dataInizio: "2024-04-25",
      dataFine: "2024-04-25",
      locandina: null,
      categoria: "E/G",
      censiti: "Tutti",
      chiusuraIscrizioni: "2024-04-10",
      chiusuraModifiche: "2024-04-20",
      avvio: "2024-03-15",
      chiusura: "2024-04-26",
      foto: null,
      status: "archived",
      squadreIscritte: 18,
      squadreConfermate: 16
    },
    {
      id: 401,
      torneo: "Scoutball Zone Bologna",
      edizione: "XX Edizione",
      luogo: "Centro Sportivo San Lazzaro",
      quota: "30€",
      caparra: 12,
      dataInizio: "2024-05-05",
      dataFine: "2024-05-05",
      locandina: null,
      categoria: "R/S, CoCa",
      censiti: "Solo AGESCI",
      chiusuraIscrizioni: "2024-04-20",
      chiusuraModifiche: "2024-05-01",
      avvio: "2024-04-01",
      chiusura: "2024-05-06",
      foto: "https://example.com/foto2.jpg",
      status: "completed",
      squadreIscritte: 35,
      squadreConfermate: 32
    },
    {
      id: 501,
      torneo: "Torneo dell'Amicizia",
      edizione: "VI Edizione",
      luogo: "Campo Rover Budrio",
      quota: "Offerta libera",
      caparra: 0,
      dataInizio: "2024-07-12",
      dataFine: "2024-07-13",
      locandina: null,
      categoria: "Tutte",
      censiti: "Tutti",
      chiusuraIscrizioni: "2024-06-28",
      chiusuraModifiche: "2024-07-08",
      avvio: "2024-06-15",
      chiusura: null,
      foto: null,
      status: "draft",
      squadreIscritte: 8,
      squadreConfermate: 5
    },
    {
      id: 601,
      torneo: "Memorial Scout Veteran",
      edizione: "III Edizione",
      luogo: "Parco Villa Ghigi",
      quota: "18€",
      caparra: 7,
      dataInizio: "2024-10-30",
      dataFine: "2024-10-30",
      locandina: null,
      categoria: "E/G, R/S",
      censiti: "Solo AGESCI",
      chiusuraIscrizioni: "2024-10-15",
      chiusuraModifiche: "2024-10-25",
      avvio: "2024-10-01",
      chiusura: null,
      foto: null,
      status: "active",
      squadreIscritte: 15,
      squadreConfermate: 12
    },
    {
      id: 801,
      torneo: "Coppa Giovani Talenti",
      edizione: "V Edizione",
      luogo: "Campo Sportivo Casalecchio",
      quota: "22€",
      caparra: 10,
      dataInizio: "2024-08-22",
      dataFine: "2024-08-22",
      locandina: null,
      categoria: "E/G",
      censiti: "Tutti",
      chiusuraIscrizioni: "2024-08-08",
      chiusuraModifiche: "2024-08-18",
      avvio: "2024-08-01",
      chiusura: "2024-08-23",
      foto: null,
      status: "completed",
      squadreIscritte: 28,
      squadreConfermate: 26
    }
  ];

  useEffect(() => {
    // Simula il caricamento dei dati
    const loadEdizioni = async () => {
      setLoading(true);
      
      // Simula una chiamata API
      await new Promise(resolve => setTimeout(resolve, 1500));
      
      setEdizioni(mockEdizioni);
      setLoading(false);
    };

    loadEdizioni();
  }, []);

  // Filtraggio e ricerca
  const filteredEdizioni = edizioni.filter(edizione => {
    const matchesSearch = edizione.torneo.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         edizione.edizione.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         edizione.luogo.toLowerCase().includes(searchTerm.toLowerCase());
    
    const matchesStatus = filterStatus === 'all' || edizione.status === filterStatus;
    
    const matchesCategoria = filterCategoria === 'all' || 
                            edizione.categoria.toLowerCase().includes(filterCategoria.toLowerCase());
    
    return matchesSearch && matchesStatus && matchesCategoria;
  });

  // Paginazione
  const totalPages = Math.ceil(filteredEdizioni.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const paginatedEdizioni = filteredEdizioni.slice(startIndex, startIndex + itemsPerPage);

  // Gestori eventi
  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  const handleFilterChange = (e) => {
    setFilterStatus(e.target.value);
    setCurrentPage(1);
  };

  const handleCategoriaChange = (e) => {
    setFilterCategoria(e.target.value);
    setCurrentPage(1);
  };

  const handleViewEdizione = (edizioneId) => {
    navigate(`/admin/edizione/${edizioneId}`);
  };

  const handleEditEdizione = (edizioneId) => {
    const edizione = edizioni.find(e => e.id === edizioneId);
    if (edizione) {
      setEditingEdizione(edizione);
      setShowCreateModal(true);
    }
  };

  const handleCardClick = (edizioneId) => {
    handleEditEdizione(edizioneId);
  };

  const handleToggleStatus = (edizioneId) => {
    console.log('Cambia stato edizione:', edizioneId);
    setEdizioni(prev => prev.map(e => 
      e.id === edizioneId 
        ? { ...e, status: e.status === 'active' ? 'archived' : 'active' }
        : e
    ));
  };

  const handleCreateNew = () => {
    setEditingEdizione(null);
    setShowCreateModal(true);
  };

  const handleCloseModal = () => {
    setShowCreateModal(false);
    setEditingEdizione(null);
  };

  const handleSaveEdizione = (edizioneData) => {
    if (editingEdizione) {
      // Modalità modifica - aggiorna l'edizione esistente
      setEdizioni(prev => prev.map(e => 
        e.id === editingEdizione.id 
          ? { ...e, ...edizioneData }
          : e
      ));
      console.log('Edizione aggiornata:', { ...editingEdizione, ...edizioneData });
    } else {
      // Modalità creazione - crea nuova edizione
      const newId = Math.max(...edizioni.map(e => e.id), 0) + 1;
      const newEdizione = {
        id: newId,
        ...edizioneData,
        squadreIscritte: 0,
        squadreConfermate: 0
      };
      console.log('Nuova edizione in creazione:', newEdizione);
      API.torneo.crea(newEdizione).then(r => {
        if(r.isSuccess){
          console.log('Nuova edizione creata:', newEdizione);
        }
        else{

        }
      });
      
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'active': return '#27ae60';
      case 'draft': return '#f39c12';
      case 'completed': return '#3498db';
      case 'archived': return '#95a5a6';
      default: return '#3498db';
    }
  };

  const getStatusText = (status) => {
    switch (status) {
      case 'active': return 'Attiva';
      case 'draft': return 'Bozza';
      case 'completed': return 'Completata';
      case 'archived': return 'Archiviata';
      default: return 'Sconosciuto';
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'Non specificata';
    
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('it-IT', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      });
    } catch (error) {
      return 'Data non valida';
    }
  };

  const isDeadlineWarning = (dateString) => {
    if (!dateString) return false;
    
    try {
      const deadline = new Date(dateString);
      const now = new Date();
      const daysUntilDeadline = Math.ceil((deadline - now) / (1000 * 60 * 60 * 24));
      
      return daysUntilDeadline <= 7 && daysUntilDeadline >= 0;
    } catch (error) {
      return false;
    }
  };

  const renderPagination = () => {
    if (totalPages <= 1) return null;

    const pages = [];
    const maxVisiblePages = 5;
    
    let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);
    
    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <button
          key={i}
          className={`pagination-btn ${currentPage === i ? 'active' : ''}`}
          onClick={() => setCurrentPage(i)}
        >
          {i}
        </button>
      );
    }

    return (
      <div className="edizioni-pagination">
        <button
          className="pagination-btn"
          onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
          disabled={currentPage === 1}
        >
          <i className="fas fa-chevron-left"></i>
        </button>
        
        {startPage > 1 && (
          <>
            <button className="pagination-btn" onClick={() => setCurrentPage(1)}>1</button>
            {startPage > 2 && <span className="pagination-ellipsis">...</span>}
          </>
        )}
        
        {pages}
        
        {endPage < totalPages && (
          <>
            {endPage < totalPages - 1 && <span className="pagination-ellipsis">...</span>}
            <button className="pagination-btn" onClick={() => setCurrentPage(totalPages)}>{totalPages}</button>
          </>
        )}
        
        <button
          className="pagination-btn"
          onClick={() => setCurrentPage(prev => Math.min(totalPages, prev + 1))}
          disabled={currentPage === totalPages}
        >
          <i className="fas fa-chevron-right"></i>
        </button>
      </div>
    );
  };

  if (loading) {
    return (
      <div className="edizioni-page">
        <div className="edizioni-container">
          <div className="edizioni-loading">
            <div className="edizioni-loading-spinner"></div>
            <p>Caricamento edizioni...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="edizioni-page">
      <div className="edizioni-container">
        {/* Header */}
        <div className="edizioni-header">
          <div className="edizioni-title">
            <i className="fas fa-calendar-alt"></i>
            <h1>Gestione Edizioni</h1>
          </div>
          
          <div className="edizioni-stats">
            <div className="edizioni-stat">
              <i className="fas fa-calendar"></i>
              <span>Totali: {edizioni.length}</span>
            </div>
            <div className="edizioni-stat">
              <i className="fas fa-play-circle"></i>
              <span>Attive: {edizioni.filter(e => e.status === 'active').length}</span>
            </div>
            <div className="edizioni-stat">
              <i className="fas fa-check-circle"></i>
              <span>Completate: {edizioni.filter(e => e.status === 'completed').length}</span>
            </div>
          </div>
          
          <div className="edizioni-actions">
            <button className="edizioni-btn edizioni-btn-success" onClick={handleCreateNew}>
              <i className="fas fa-plus"></i>
              Nuova Edizione
            </button>
          </div>
        </div>

        {/* Filtri e ricerca */}
        <div className="edizioni-filters">
          <div className="edizioni-search">
            <i className="fas fa-search"></i>
            <input
              type="text"
              placeholder="Cerca edizioni per torneo, edizione o luogo..."
              value={searchTerm}
              onChange={handleSearchChange}
            />
          </div>
          
          <select 
            className="edizioni-filter-select"
            value={filterStatus}
            onChange={handleFilterChange}
          >
            <option value="all">Tutti gli stati</option>
            <option value="active">Attive</option>
            <option value="draft">Bozze</option>
            <option value="completed">Completate</option>
            <option value="archived">Archiviate</option>
          </select>

          <select 
            className="edizioni-filter-select"
            value={filterCategoria}
            onChange={handleCategoriaChange}
          >
            <option value="all">Tutte le categorie</option>
            <option value="l/c">L/C</option>
            <option value="e/g">E/G</option>
            <option value="r/s">R/S</option>
            <option value="coca">CoCa</option>
          </select>
        </div>

        {/* Grid edizioni o stato vuoto */}
        {filteredEdizioni.length === 0 ? (
          <div className="edizioni-empty">
            <i className="fas fa-calendar-times"></i>
            <h3>Nessuna edizione trovata</h3>
            <p>
              {searchTerm || filterStatus !== 'all' || filterCategoria !== 'all'
                ? 'Non ci sono edizioni che corrispondono ai criteri di ricerca.'
                : 'Non hai ancora creato nessuna edizione. Inizia creando la tua prima edizione!'
              }
            </p>
            {!searchTerm && filterStatus === 'all' && filterCategoria === 'all' && (
              <button className="edizioni-btn edizioni-btn-success" onClick={handleCreateNew}>
                <i className="fas fa-plus"></i>
                Crea la tua prima edizione
              </button>
            )}
          </div>
        ) : (
          <>
            <div className="edizioni-grid">
              {paginatedEdizioni.map((edizione) => (
                <div 
                  key={edizione.id} 
                  className="edizione-card"
                  onClick={() => handleCardClick(edizione.id)}
                >
                  <div className="edizione-card-header">
                    <div 
                      className="edizione-card-badge"
                      style={{ backgroundColor: getStatusColor(edizione.status) }}
                    >
                      {getStatusText(edizione.status)}
                    </div>
                    <h3 className="edizione-card-title">{edizione.torneo}</h3>
                    <p className="edizione-card-subtitle">{edizione.edizione}</p>
                  </div>
                  
                  <div className="edizione-card-body">
                    <div className="edizione-card-meta">
                      <div className="edizione-meta-item">
                        <i className="fas fa-map-marker-alt"></i>
                        <span className="edizione-meta-value">{edizione.luogo}</span>
                      </div>
                      <div className="edizione-meta-item">
                        <i className="fas fa-calendar-alt"></i>
                        <span className="edizione-meta-value">
                          {formatDate(edizione.dataInizio)}
                          {edizione.dataInizio !== edizione.dataFine && 
                            ` - ${formatDate(edizione.dataFine)}`}
                        </span>
                      </div>
                      <div className="edizione-meta-item">
                        <i className="fas fa-euro-sign"></i>
                        <span className="edizione-meta-value">{edizione.quota}</span>
                      </div>
                      <div className="edizione-meta-item">
                        <i className="fas fa-users"></i>
                        <span className="edizione-meta-value">{edizione.categoria}</span>
                      </div>
                      <div className={`edizione-meta-item ${isDeadlineWarning(edizione.chiusuraIscrizioni) ? 'deadline-warning' : ''}`}>
                        <i className="fas fa-clock"></i>
                        <span className="edizione-meta-value">
                          Scadenza: {formatDate(edizione.chiusuraIscrizioni)}
                          {isDeadlineWarning(edizione.chiusuraIscrizioni) && 
                            <span className="warning-text"> - ATTENZIONE!</span>}
                        </span>
                      </div>
                      <div className="edizione-meta-item">
                        <i className="fas fa-chart-bar"></i>
                        <span className="edizione-meta-value">
                          Squadre: {edizione.squadreConfermate}/{edizione.squadreIscritte}
                        </span>
                      </div>
                    </div>
                  </div>
                  
                  <div className="edizione-card-actions" onClick={(e) => e.stopPropagation()}>
                    <button 
                      className="edizione-btn edizione-btn-view"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleViewEdizione(edizione.id);
                      }}
                      title="Visualizza edizione"
                    >
                      <i className="fas fa-eye"></i>
                      Visualizza
                    </button>
                    <button 
                      className="edizione-btn edizione-btn-edit"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleEditEdizione(edizione.id);
                      }}
                      title="Modifica edizione"
                    >
                      <i className="fas fa-edit"></i>
                      Modifica
                    </button>
                    <button 
                      className={`edizione-btn ${edizione.status === 'active' ? 'edizione-btn-delete' : 'edizione-btn-view'}`}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleToggleStatus(edizione.id);
                      }}
                      title={edizione.status === 'active' ? 'Disattiva edizione' : 'Attiva edizione'}
                    >
                      <i className={`fas ${edizione.status === 'active' ? 'fa-pause' : 'fa-play'}`}></i>
                      {edizione.status === 'active' ? 'Disattiva' : 'Attiva'}
                    </button>
                  </div>
                </div>
              ))}
            </div>

            {/* Paginazione */}
            {renderPagination()}
          </>
        )}

        {/* Modal per creazione/modifica edizione */}
        <CreateEdizioneModal
          isOpen={showCreateModal}
          onClose={handleCloseModal}
          onSubmit={handleSaveEdizione}
          editingEdizione={editingEdizione}
        />
      </div>
    </div>
  );
};

export default Edizioni;